import React, { useState, useEffect } from 'react';
import { BarChart, Bar, YAxis, XAxis, Tooltip, LabelList, ResponsiveContainer } from 'recharts';
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';
import { startOfTomorrow, differenceInSeconds } from 'date-fns';
// import Cookies from 'js-cookie';
import { StreakNumber, MaxStreakNumber } from './DailyStreak';
import ShareButton from './ShareButton';
import './style/statistics.scss'

export const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        return (
            <div className="custom-tooltip">
                <p className="label">{`Guesses: ${payload[0].payload.name}`}</p>
                <p className="intro">{`Count: ${payload[0].value}`}</p>
            </div>
        );
    }
    return null;
};

const CustomizedLabel = (props) => {
    const { x, y, width, height, value } = props;
    const yPos = y + (height / 2) + 5;
    const xPos = x + width - 10;
    return <text x={xPos} y={yPos} className="custom-label">{value}</text>
};

const Statistics = ({ chartData, todaysRiddle }) => {
    const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining());
    const [gamesPlayed, setGamesPlayed] = useState(0);
    const [winPercentage, setWinPercentage] = useState(0);
    const [todaysResult, setTodaysResult] = useState(null);

    function calculateTimeRemaining() {
        const currentTimeInNY = utcToZonedTime(new Date(), 'America/New_York');
        const nextMidnightInNY = zonedTimeToUtc(startOfTomorrow(currentTimeInNY), 'America/New_York');
        return differenceInSeconds(nextMidnightInNY, new Date());
    }

    useEffect(() => {
        // Load games played and win percentage from cookie when the component mounts
        const riddleStats = localStorage.getItem('riddleStats');
        if (riddleStats) {
            const games = JSON.parse(riddleStats);
            const totalGames = Object.keys(games).length;
            const gamesWon = Object.values(games).filter(game => game.solved).length;
            setGamesPlayed(totalGames);
            setWinPercentage((gamesWon / totalGames) * 100);
            const lastGameKey = Object.keys(games).sort().pop(); 
            setTodaysResult(games[lastGameKey]); 
        }

        const timer = setInterval(() => {
            setTimeRemaining(calculateTimeRemaining());
        }, 1000);
        return () => clearInterval(timer);
    }, []); 

    function secondsToHms(seconds) {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = Math.floor((seconds % 3600) % 60);

        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }

    return (
        chartData && 
        <div className="chart-container">
            <h3 className="chart-title">Statistics</h3>
            <div className="statistic-line">
                <div className="statistic">
                    <p>{gamesPlayed}</p>
                    <p><span>Games played</span></p>
                </div>
                <div className="statistic">
                    <p>{winPercentage.toFixed(0)}%</p>
                    <p><span>Win Percentage</span></p>
                </div>
                <div className="statistic">
                    <p><StreakNumber /></p>
                    <p><span>Current <br/>Streak</span></p>
                </div>
                <div className="statistic">
                    <p><MaxStreakNumber /></p>
                    <p><span>Max <br/>Streak</span></p>
                </div>
            </div>
            <h3 className="chart-title">Solve Distribution</h3>
            <ResponsiveContainer width='80%' height={160}>
                <BarChart data={chartData} layout="vertical" barGap={5}>
                    <YAxis type="category" dataKey="name" axisLine={false} tickLine={false} />
                    <XAxis type="number" domain={[0, 'dataMax']} hide={true} />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="count" fill="#8884d8" barSize={25} minPointSize={18}>
                        <LabelList dataKey="count" content={<CustomizedLabel />} position="insideTop" />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
            <div className="next-ridella-share">
                <div className="next-ridella">
                    <p>Next Ridella: {secondsToHms(timeRemaining)}</p>
                    {/* <p>{secondsToHms(timeRemaining)}</p> */}
                </div>
                {/* <div className="share-button-wrapper">
                    <ShareButton todaysRiddle={todaysRiddle} />
                </div> */}
            </div>
        </div>
    );
};

export default Statistics;
